module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAdklEQVR42u3QQQ0AIAwEQUwhABE4xB8SSvDQ302TTfq9GVU1koseDwAAAAAAAAAAAADAf/apzrrvrtkaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkASQGgAAAAAAAAAAAAAAoT2Kz+HEy0UcugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/country/fr-FR.png
// module id = +WCL
// module chunks = 1